import { useLocation } from 'react-router-dom';

const useEnterpriseId = (): string => {
  const { pathname } = useLocation();
  const enterpriseId = pathname.split('/')[2];
  return enterpriseId?.startsWith('E') ? enterpriseId : '';
};

export default useEnterpriseId;
